export function UnstyledList({ children, ...props }) {
  return (
    <ul
      sx={{
        listStyle: 'none',
        padding: 0,
        margin: 0
      }}
      {...props}
    >
      {children}
    </ul>
  );
}

export function ListItem({ children, ...props }) {
  return <li {...props}>{children}</li>
}
